import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcOverview = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-icon-accent)",
  height: "10",
  rx: "1",
  width: "8",
  x: "3",
  y: "4"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M3 17a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2ZM13 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("rect", {
  fill: "var(--mds-nav-icon-weak)",
  height: "8",
  rx: "1",
  width: "8",
  x: "13",
  y: "12"
})), "IcOverview");

export { IcOverview };
//# sourceMappingURL=ic-overview.js.map
